// 自動見積もりデータ送信先のエンドポイント
export const estimateEndpoint =
  'https://api.retool.com/v1/workflows/46ea8f3d-09e9-4a80-8ef2-7b337b31f119/startTrigger?workflowApiKey=retool_wk_cb87ed36b355402484b0c8026d527a5d';
// 提案プランページ回答テンプレート取得エンドポイント
export const planRequestEndpoint =
  'https://api.retool.com/v1/workflows/32cb9123-5c5e-4a62-953c-4091d3afa914/startTrigger?workflowApiKey=retool_wk_2a52f0500dda4c2789165defc8687c4d';
// 提案プランページ回答テンプレート送信エンドポイント
export const planSubmitEndpoint =
  'https://api.retool.com/v1/workflows/27af6265-4fab-499a-a802-f84dc33317d4/startTrigger?workflowApiKey=retool_wk_8388fad0b09f476cb77cf4b942d2949d';
// 梱包ページ注文ID取得エンドポイント
export const requestIdEndpoint =
  'https://api.retool.com/v1/workflows/d8bf592b-bbac-4cc2-97e3-074513393522/startTrigger?workflowApiKey=retool_wk_321c2ee2678f41bfbf09975b1b9ad303';
